export const nodesRu: Record<string, string> = {
  'action_0_0': '+5% к увеличению урона от действий',
  'action_0_1': '+5% шанс нанести двойной урон действием',
  'action_0_2': '+12% к увеличению урона от действий',
  'action_0_3': '+5% к увеличению урона от действий',
  'action_0_4': '+5% шанс нанести двойной урон действием',
  'action_0_5': '+20% к дополнительному урону от действий',
  'action_0_6': '+5% к увеличению урона от действий',
  'action_0_7': '+5% шанс нанести двойной урон действием',
  'action_0_8': '+5% шанс нанести двойной урон действием · +5% к увеличению урона от действий · +5% к увеличению скорости действий',
  'action_0_9': '+5% к увеличению урона от действий',
  'action_0_10': '+5% шанс нанести двойной урон действием',
  'action_0_11': 'Попадания действий имеют на 20% больший шанс игнорировать все снижения урона врага',
  'action_0_12': '+10% к дополнительному урону от действий · Скорость действий снижена на 6%',
  'action_0_13': '+10% к дополнительному урону от действий · +20% к дополнительной стоимости маны действий',
  'action_0_14': '+15% к увеличению шанса нанести двойной урон действием',
  'action_0_15': '+10% к дополнительному урону от действий',

  'action_1_0': '+4% к увеличению скорости действий',
  'action_1_1': '+3% к увеличению шанса повторного действия',
  'action_1_2': '+10% к увеличению скорости действий',
  'action_1_3': '+4% к увеличению скорости действий',
  'action_1_4': '+3% к увеличению шанса повторного действия',
  'action_1_5': '+20% к дополнительной скорости действий',
  'action_1_6': '+4% к увеличению скорости действий',
  'action_1_7': '+3% к увеличению шанса повторного действия',
  'action_1_8': '+4% к увеличению скорости действий · +3% к увеличению шанса повторного действия · +5% к увеличению урона от действий',
  'action_1_9': '+4% к увеличению скорости действий',
  'action_1_10': '+3% к увеличению шанса повторного действия',
  'action_1_11': 'При повторном действии второй начальный удар гарантированно активирует недуги',
  'action_1_12': '+10% к дополнительной скорости действий · Урон от действий снижен на 10%',
  'action_1_13': '+5% к увеличению шанса повторного действия',
  'action_1_14': 'Двойные действия перебрасывают кубик ещё раз на повторение',
  'action_1_15': 'Двойных действий нет; шанс двойного действия конвертируется в шанс двойного урона',

  'action_2_0': 'Действия имеют +2% шанс активировать Транс',
  'action_2_1': 'Действия в Трансе: +5% шанс поразить дополнительного врага · +5% увеличение урона · +5% увеличение скорости действий',
  'action_2_2': 'Действия имеют +5% шанс активировать Транс',
  'action_2_3': 'Действия имеют +2% шанс активировать Транс',
  'action_2_4': 'Действия в Трансе: +5% шанс поразить дополнительного врага · +5% увеличение урона · +5% увеличение скорости действий',
  'action_2_5': 'Действия имеют +3% шанс активировать Транс · Действия в Трансе: +8% шанс поразить дополнительного врага · +8% увеличение урона · +8% увеличение скорости действий',
  'action_2_12': 'Транс может накапливаться один раз · Длительность Транса уменьшена вдвое',
  'action_2_13': 'Действия имеют +5% шанс активировать Транс',

  'action_3_0': '+10% к снижению стоимости маны действий',
  'action_3_1': '+10% шанс, что действия не тратят ману',
  'action_3_2': 'Действия тратят 0–33% меньше маны (случайно для каждого действия)',
  'action_3_3': '+10% к снижению стоимости маны действий',
  'action_3_4': '+10% шанс, что действия не тратят ману',
  'action_3_5': '+10% к снижению стоимости маны действий · +10% шанс, что действия не тратят ману · Повторные действия игнорируют требование к мане',
  'action_3_12': 'Снижения стоимости маны из этого дерева вместо этого увеличивают стоимость · Шанс бесплатного действия становится шансом двойной стоимости маны',
  'action_3_13': 'Стоимость маны действий снижена на 30%',

  'criticalHit_0_0': '+10% к увеличению урона критических ударов',
  'criticalHit_0_1': '+10% к увеличению урона критических ударов',
  'criticalHit_0_2': '+20% к увеличению урона критических ударов · +10% к увеличению шанса критического удара',
  'criticalHit_0_3': '+10% к увеличению урона критических ударов',
  'criticalHit_0_4': '+10% к увеличению урона критических ударов',
  'criticalHit_0_5': 'Критические удары имеют на +20% больший шанс игнорировать все снижения урона врага',
  'criticalHit_0_6': '+10% к увеличению урона критических ударов',
  'criticalHit_0_7': '+10% к увеличению урона критических ударов',
  'criticalHit_0_8': '+20% к увеличению урона критических ударов · +10% к увеличению шанса критического удара',
  'criticalHit_0_9': '+10% к увеличению урона критических ударов',
  'criticalHit_0_10': '+10% к увеличению урона критических ударов',
  'criticalHit_0_11': '+20% к дополнительному урону критических ударов',
  'criticalHit_0_12': '+10% к дополнительному урону критических ударов',
  'criticalHit_0_13': '+10% шанс, что критические удары игнорируют все снижения урона врага',
  'criticalHit_0_14': 'Бонус урона критических ударов из этого дерева применяется к урону от недугов при критических ударах, а не к прямым попаданиям',
  'criticalHit_0_15': 'Двойной урон становится тройным, если критический удар также выпал двойной урон',

  'criticalHit_1_0': '+10% к увеличению шанса критического удара',
  'criticalHit_1_1': '+10% к увеличению шанса критического удара',
  'criticalHit_1_2': '+20% к увеличению шанса критического удара · +10% к увеличению урона критических ударов',
  'criticalHit_1_3': '+10% к увеличению шанса критического удара',
  'criticalHit_1_4': '+10% к увеличению шанса критического удара',
  'criticalHit_1_5': '+3% базовый шанс критического удара действий',
  'criticalHit_1_6': '+10% к увеличению шанса критического удара',
  'criticalHit_1_7': '+10% к увеличению шанса критического удара',
  'criticalHit_1_8': '+20% к увеличению шанса критического удара · +10% к увеличению урона критических ударов',
  'criticalHit_1_9': '+10% к увеличению шанса критического удара',
  'criticalHit_1_10': '+10% к увеличению шанса критического удара',
  'criticalHit_1_11': '+20% к дополнительному шансу критического удара',
  'criticalHit_1_12': '+2% базовый шанс критического удара действий',
  'criticalHit_1_13': '+10% к дополнительному шансу критического удара',
  'criticalHit_1_14': 'Критические удары накладывают гарантированный недуг · Критические удары не наносят дополнительный урон',
  'criticalHit_1_15': '+20% к дополнительному шансу критического удара против врагов с любым недугом',

  'physical_0_0': '+5% к увеличению физического урона',
  'physical_0_1': '+3% к увеличению скорости физических действий',
  'physical_0_2': '+5% к увеличению физического урона · Физические действия имеют +5% шанс применить кровотечение',
  'physical_0_3': '+5% к увеличению физического урона',
  'physical_0_4': '+3% к увеличению скорости физических действий',
  'physical_0_5': '+10% к дополнительному физическому урону',
  'physical_0_6': '+5% к увеличению физического урона',
  'physical_0_7': '+3% к увеличению скорости физических действий',
  'physical_0_8': '+12% к увеличению физического урона',
  'physical_0_9': '+5% к увеличению физического урона',
  'physical_0_10': '+3% к увеличению скорости физических действий',
  'physical_0_11': 'Кровоточащие враги получают +10% дополнительного физического урона',

  'physical_1_0': 'Физические действия имеют +5% шанс применить кровотечение',
  'physical_1_1': '+15% к увеличению урона от кровотечения',
  'physical_1_2': '+30% к увеличению урона от кровотечения · +10% к увеличению длительности кровотечения',
  'physical_1_3': 'Физические действия имеют +5% шанс применить кровотечение',
  'physical_1_4': '+15% к увеличению урона от кровотечения',
  'physical_1_5': '+30% к дополнительному урону от кровотечения',
  'physical_1_6': 'Физические действия имеют +5% шанс применить кровотечение',
  'physical_1_7': '+15% к увеличению урона от кровотечения',
  'physical_1_8': '+60% к увеличению урона от кровотечения',
  'physical_1_9': 'Физические действия имеют +5% шанс применить кровотечение',
  'physical_1_10': '+15% к увеличению урона от кровотечения',
  'physical_1_11': 'Кровотечение игнорирует физическое сопротивление врага',
  'physical_1_12': '+30% к дополнительному урону от кровотечения · Длительность кровотечения уменьшена вдвое',
  'physical_1_13': 'Длительность кровотечения удвоена · Урон от кровотечения снижен на 30%',
  'physical_1_14': 'Урон от кровотечения удвоен · Вы не наносите урон ударами',
  'physical_1_15': '+10% к дополнительному урону от кровотечения',

  'physical_2_0': 'Физические действия имеют +5% шанс навсегда снизить физическое и гнилостное сопротивление врага на 1%',
  'physical_2_1': '+5% к увеличению физического урона',
  'physical_2_2': 'Физические действия имеют +7% шанс навсегда снизить физическое и гнилостное сопротивление врага на 1% · +3% к увеличению скорости физических действий',
  'physical_2_3': 'Физические действия имеют +5% шанс навсегда снизить физическое и гнилостное сопротивление врага на 1%',
  'physical_2_4': '+5% к увеличению физического урона',
  'physical_2_5': 'Враги с 0% физического и гнилостного сопротивления получают снижение скорости действий и передвижения на 20%',

  'physical_3_0': '+5% к увеличению шанса активировать Кровожадность при нанесении кровотечения',
  'physical_3_1': 'Кровожадность даёт +5% к увеличению скорости физических действий',
  'physical_3_2': 'Кровожадность даёт +5% к увеличению скорости физических действий и +12% к увеличению физического урона · Физические действия в состоянии Кровожадности имеют +10% шанс вызвать кровотечение',
  'physical_3_3': '+5% к увеличению шанса активировать Кровожадность при нанесении кровотечения',
  'physical_3_4': 'Кровожадность даёт +5% к увеличению скорости физических действий',
  'physical_3_5': 'Кровожадность даёт +5% к увеличению скорости физических действий и +12% к увеличению физического урона · +25% к увеличению длительности Кровожадности',

  'fire_0_0': '+5% к увеличению урона от огня',
  'fire_0_1': '+3% к увеличению скорости огненных действий',
  'fire_0_2': '+5% к увеличению урона от огня · Огненные действия имеют +5% шанс поджечь',
  'fire_0_3': '+5% к увеличению урона от огня',
  'fire_0_4': '+3% к увеличению скорости огненных действий',
  'fire_0_5': '+10% к дополнительному урону от огня',
  'fire_0_6': '+5% к увеличению урона от огня',
  'fire_0_7': '+3% к увеличению скорости огненных действий',
  'fire_0_8': '+12% к увеличению урона от огня',
  'fire_0_9': '+5% к увеличению урона от огня',
  'fire_0_10': '+3% к увеличению скорости огненных действий',
  'fire_0_11': 'Горящие враги имеют на 20% меньше сопротивления огню',

  'fire_1_0': 'Огненные действия имеют +5% шанс поджечь',
  'fire_1_1': '+15% к увеличению урона от ожога',
  'fire_1_2': '+30% к увеличению урона от ожога · +10% к увеличению длительности ожога',
  'fire_1_3': 'Огненные действия имеют +5% шанс поджечь',
  'fire_1_4': '+15% к увеличению урона от ожога',
  'fire_1_5': '+30% к дополнительному урону от ожога',
  'fire_1_6': 'Огненные действия имеют +5% шанс поджечь',
  'fire_1_7': '+15% к увеличению урона от ожога',
  'fire_1_8': 'Горящие враги получают +30% увеличения урона от всех источников',
  'fire_1_9': 'Огненные действия имеют +5% шанс поджечь',
  'fire_1_10': '+15% к увеличению урона от ожога',
  'fire_1_11': 'Горящие враги передают 50% урона от своего ожога ближайшим негорящим врагам',
  'fire_1_12': '+30% к дополнительному урону от ожога · Длительность ожога уменьшена вдвое',
  'fire_1_13': 'Длительность ожога удвоена · Урон от ожога снижен на 30%',
  'fire_1_14': 'Урон от ожога удвоен · Вы не наносите урон ударами',
  'fire_1_15': '+10% к дополнительному урону от ожога',

  'fire_2_0': 'Огненные действия имеют +5% шанс создать горящую землю',
  'fire_2_1': '+45% к увеличению урона горящей земли',
  'fire_2_2': '+90% к увеличению урона горящей земли · +30% к увеличению длительности горящей земли',
  'fire_2_3': 'Огненные действия имеют +5% шанс создать горящую землю',
  'fire_2_4': '+45% к увеличению урона горящей земли',
  'fire_2_5': 'Горящая земля замедляет скорость передвижения и действий врагов на 20% · +30% к дополнительному урону горящей земли',

  'fire_3_0': 'Огненные действия имеют +2% шанс активировать Самосожжение',
  'fire_3_1': 'Во время Самосожжения: +5% к увеличению урона от огня · +5% к увеличению шанса поджечь',
  'fire_3_2': 'Урон от самоожога при Самосожжении уменьшен вдвое (×0,5)',
  'fire_3_3': 'Огненные действия имеют +2% шанс активировать Самосожжение',
  'fire_3_4': 'Во время Самосожжения: +5% к увеличению урона от огня · +5% к увеличению шанса поджечь',
  'fire_3_5': 'Огненные действия имеют +5% шанс активировать Самосожжение · Во время Самосожжения: +10% к увеличению урона от огня · +10% к увеличению шанса поджечь · Урон от самоожога при Самосожжении уменьшен вдвое (×0,5)',

  'lightning_0_0': '+5% к увеличению урона от молнии',
  'lightning_0_1': '+3% к увеличению скорости действий с молнией',
  'lightning_0_2': '+5% к увеличению урона от молнии · Действия молнии имеют +5% шанс электрошока',
  'lightning_0_3': '+5% к увеличению урона от молнии',
  'lightning_0_4': '+3% к увеличению скорости действий с молнией',
  'lightning_0_5': '+10% к дополнительному урону от молнии',
  'lightning_0_6': '+5% к увеличению урона от молнии',
  'lightning_0_7': '+3% к увеличению скорости действий с молнией',
  'lightning_0_8': '+12% к увеличению урона от молнии',
  'lightning_0_9': '+5% к увеличению урона от молнии',
  'lightning_0_10': '+3% к увеличению скорости действий с молнией',
  'lightning_0_11': '+10% к дополнительному урону от молнии · +5% к дополнительной скорости действий с молнией',

  'lightning_1_0': 'Действия молнии имеют +5% шанс электрошока',
  'lightning_1_1': '+3% к увеличению урона, получаемого от электрошока',
  'lightning_1_2': '+5% к увеличению урона, получаемого от электрошока · +10% к увеличению длительности электрошока',
  'lightning_1_3': 'Действия молнии имеют +5% шанс электрошока',
  'lightning_1_4': '+3% к увеличению урона, получаемого от электрошока',
  'lightning_1_5': '+8% к увеличению урона, получаемого от электрошока · +20% к увеличению длительности электрошока',
  'lightning_1_6': 'Действия молнии имеют +5% шанс электрошока',
  'lightning_1_7': '+3% к увеличению урона, получаемого от электрошока',
  'lightning_1_8': 'Действия молнии имеют +15% шанс электрошока',
  'lightning_1_9': 'Действия молнии имеют +5% шанс электрошока',
  'lightning_1_10': '+3% к увеличению урона, получаемого от электрошока',
  'lightning_1_11': 'У врагов под электрошоком скорость передвижения и действий снижается на величину получаемого урона от электрошока',
  'lightning_1_12': '+5% к увеличению урона, получаемого от электрошока · Длительность электрошока снижена на 10%',
  'lightning_1_13': 'Длительность электрошока увеличена на 20%',
  'lightning_1_14': 'Действия молнии имеют +5% дополнительного шанса перепрыгнуть от врага под электрошоком',
  'lightning_1_15': '+5% к увеличению урона, получаемого от электрошока',

  'lightning_2_0': 'Действия молнии имеют +20% шанс перепрыгнуть на дополнительного врага',
  'lightning_2_1': '+10% к снижению штрафа урона прыжка',
  'lightning_2_2': 'Действия молнии имеют +30% шанс перепрыгнуть на дополнительного врага · +15% к снижению штрафа урона прыжка',
  'lightning_2_3': 'Действия молнии имеют +20% шанс перепрыгнуть на дополнительного врага',
  'lightning_2_4': '+10% к снижению штрафа урона прыжка',
  'lightning_2_5': 'Успешные прыжки повторно бросают кубик для ещё одного прыжка (бесконечная цепь) · +30% к увеличению дальности прыжка',

  'lightning_3_0': 'Действия молнии имеют +5% дополнительного шанса Наэлектризовать вас',
  'lightning_3_1': '+5% к увеличению скорости действий в состоянии Наэлектризованности',
  'lightning_3_2': '+25% к увеличению длительности Наэлектризованности · +5% к увеличению скорости действий в состоянии Наэлектризованности',
  'lightning_3_3': 'Действия молнии имеют +5% дополнительного шанса Наэлектризовать вас',
  'lightning_3_4': '+5% к увеличению скорости действий в состоянии Наэлектризованности',
  'lightning_3_5': 'В состоянии Наэлектризованности получаемый урон от всех источников снижен на 5%',

  'area_0_0': '+5% к увеличению урона по области',
  'area_0_1': '+5% шанс нанести двойной урон по области',
  'area_0_2': '+12% к увеличению урона по области',
  'area_0_3': '+5% к увеличению урона по области',
  'area_0_4': '+5% шанс нанести двойной урон по области',
  'area_0_5': '+20% к дополнительному урону по области',
  'area_0_6': '+5% к увеличению урона по области',
  'area_0_7': '+5% шанс нанести двойной урон по области',
  'area_0_8': '+5% шанс нанести двойной урон по области · +5% к увеличению урона по области · +5% к увеличению размера области',
  'area_0_9': '+5% к увеличению урона по области',
  'area_0_10': '+5% шанс нанести двойной урон по области',
  'area_0_11': '+30% к дополнительному урону по области · Скорость действий по области снижена на 15%',

  'area_1_0': '+5% к увеличению радиуса действий по области',
  'area_1_1': '+5% к увеличению урона по области',
  'area_1_2': '+12% к увеличению радиуса действий по области',
  'area_1_3': '+5% к увеличению радиуса действий по области',
  'area_1_4': '+5% к увеличению урона по области',
  'area_1_5': '+15% к дополнительному радиусу действий по области',
  'area_1_6': '+5% к увеличению радиуса действий по области',
  'area_1_7': '+5% к увеличению урона по области',
  'area_1_8': '+8% к увеличению радиуса действий по области · +5% к увеличению урона по области',
  'area_1_9': '+5% к увеличению радиуса действий по области',
  'area_1_10': '+5% к увеличению урона по области',
  'area_1_11': '+10% к дополнительному радиусу действий по области · +10% к дополнительному урону по области · Скорость действий по области снижена на 10%',

  'area_2_0': 'Действия по области имеют +5% дополнительного шанса вызвать толчок земли',
  'area_2_1': 'Толчки земли наносят +5% увеличенного урона',
  'area_2_2': 'Действия по области имеют +8% дополнительного шанса вызвать толчок земли · Толчки земли имеют +8% увеличенного радиуса области',
  'area_2_3': 'Действия по области имеют +5% дополнительного шанса вызвать толчок земли',
  'area_2_4': 'Толчки земли наносят +5% увеличенного урона',
  'area_2_5': 'Действия по области имеют +7% дополнительного шанса вызвать толчок земли · Толчки земли имеют +7% увеличенного радиуса области · Толчки земли наносят +7% увеличенного урона',

  'area_3_0': 'Попадания по области имеют +10% шанс отбросить цель',
  'area_3_1': 'Отброшенные враги имеют на 10% меньшую скорость передвижения в течение 2 секунд',
  'area_3_2': 'Попадания по области имеют +15% шанс отбросить цель · +15% к увеличению урона по области',
  'area_3_3': 'Попадания по области имеют +10% шанс отбросить цель',
  'area_3_4': 'Отброшенные враги имеют на 10% меньшую скорость передвижения в течение 2 секунд',
  'area_3_5': '+30% к дополнительной дальности отброса · Отброшенные враги наносят на 10% меньше урона в течение 2 секунд',

  'projectile_0_0': '+5% к увеличению урона от снарядов',
  'projectile_0_1': '+5% шанс поразить дополнительную цель',
  'projectile_0_2': '+12% к увеличению урона от снарядов',
  'projectile_0_3': '+5% к увеличению урона от снарядов',
  'projectile_0_4': '+5% шанс поразить дополнительную цель',
  'projectile_0_5': '+20% к дополнительному урону от снарядов',
  'projectile_0_6': '+5% к увеличению урона от снарядов',
  'projectile_0_7': '+5% шанс поразить дополнительную цель',
  'projectile_0_8': '+5% шанс поразить дополнительную цель · +5% к увеличению урона от снарядов · +5% к увеличению скорости действий',
  'projectile_0_9': '+5% к увеличению урона от снарядов',
  'projectile_0_10': '+5% шанс поразить дополнительную цель',
  'projectile_0_11': '+20% шанс нанести двойной урон · +10% к увеличению дальности снарядов',

  'projectile_1_0': '+5% шанс выпустить дополнительный снаряд с 50% урона',
  'projectile_1_1': '+5% к увеличению урона дополнительных снарядов',
  'projectile_1_2': '+7% шанс выпустить дополнительный снаряд · +7% к увеличению урона дополнительных снарядов',
  'projectile_1_3': '+5% шанс выпустить дополнительный снаряд',
  'projectile_1_4': '+5% к увеличению урона дополнительных снарядов',
  'projectile_1_5': '+15% шанс выпустить дополнительный снаряд',
  'projectile_1_6': '+5% шанс выпустить дополнительный снаряд',
  'projectile_1_7': '+5% к увеличению урона дополнительных снарядов',
  'projectile_1_8': '+7% шанс выпустить дополнительный снаряд · +7% к увеличению урона дополнительных снарядов',
  'projectile_1_9': '+5% шанс выпустить дополнительный снаряд',
  'projectile_1_10': '+5% к увеличению урона дополнительных снарядов',
  'projectile_1_11': 'При выпуске дополнительного снаряда бросается кубик ещё раз для второго дополнительного снаряда',

  'projectile_2_0': '+5% к увеличению дальности снарядов',
  'projectile_2_1': '+5% к увеличению урона от снарядов',
  'projectile_2_2': '+12% к увеличению дальности снарядов',
  'projectile_2_3': '+5% к увеличению дальности снарядов',
  'projectile_2_4': '+5% к увеличению урона от снарядов',
  'projectile_2_5': '+5% к увеличению урона от снарядов за 1 единицу дальности (минимум 5% при дальности 1)',

  'projectile_3_0': 'Попадания снарядов имеют +10% шанс отбросить цель',
  'projectile_3_1': 'Отброшенные враги имеют на 10% меньшую скорость передвижения в течение 2 секунд',
  'projectile_3_2': 'Попадания снарядов имеют +15% шанс отбросить цель · +15% к увеличению урона от снарядов',
  'projectile_3_3': 'Попадания снарядов имеют +10% шанс отбросить цель',
  'projectile_3_4': 'Отброшенные враги имеют на 10% меньшую скорость передвижения в течение 2 секунд',
  'projectile_3_5': '+30% к дополнительной дальности отброса · Отброшенные враги наносят на 10% меньше урона в течение 2 секунд',

  'strike_0_0': '+5% к увеличению урона ударов',
  'strike_0_1': '+5% шанс нанести двойной урон ударом',
  'strike_0_2': '+12% к увеличению урона ударов',
  'strike_0_3': '+5% к увеличению урона ударов',
  'strike_0_4': '+5% шанс нанести двойной урон ударом',
  'strike_0_5': '+20% к дополнительному урону ударов',
  'strike_0_6': '+5% к увеличению урона ударов',
  'strike_0_7': '+5% шанс нанести двойной урон ударом',
  'strike_0_8': '+5% шанс нанести двойной урон ударом · +5% к увеличению урона ударов · +5% к увеличению скорости действий',
  'strike_0_9': '+5% к увеличению урона ударов',
  'strike_0_10': '+5% шанс нанести двойной урон ударом',
  'strike_0_11': 'Удары имеют +20% дополнительного шанса активировать недуги',

  'strike_1_0': 'Удары имеют +5% дополнительного шанса активировать Раж',
  'strike_1_1': 'Раж даёт +1% увеличения урона и скорости действий за каждый заряд',
  'strike_1_2': 'Удары имеют +5% дополнительного шанса активировать Раж · Раж даёт фиксированный +10% увеличения урона и скорости действий',
  'strike_1_3': 'Удары имеют +5% дополнительного шанса активировать Раж',
  'strike_1_4': 'Раж даёт +1% увеличения урона и скорости действий за каждый заряд',
  'strike_1_5': 'Раж имеет +1% дополнительного шанса активировать недуги за каждый заряд',
  'strike_1_6': 'Удары имеют +5% дополнительного шанса активировать Раж',
  'strike_1_7': 'Раж даёт +1% увеличения урона и скорости действий за каждый заряд',
  'strike_1_8': 'Удары имеют +5% дополнительного шанса активировать Раж · Раж имеет +20% увеличения длительности · Раж даёт +1% увеличения урона и скорости действий за каждый заряд',
  'strike_1_9': 'Удары имеют +5% дополнительного шанса активировать Раж',
  'strike_1_10': 'Раж даёт +1% увеличения урона и скорости действий за каждый заряд',
  'strike_1_11': 'Раж имеет на 10 дополнительных максимальных зарядов',

  'strike_2_0': '+5% к увеличению дальности ударов',
  'strike_2_1': '+3% к увеличению скорости ударных действий',
  'strike_2_2': '+5% к увеличению дальности ударов · +5% к увеличению урона ударов',
  'strike_2_3': '+5% к увеличению дальности ударов',
  'strike_2_4': '+3% к увеличению скорости ударных действий',
  'strike_2_5': '+10% к дополнительной дальности ударов · +5% к дополнительной скорости ударных действий · Удары имеют +10% шанс всплеска',

  'strike_3_0': '+8% к увеличению шанса ударных действий поразить дополнительного врага',
  'strike_3_1': '+3% к увеличению скорости ударных действий',
  'strike_3_2': '+15% к увеличению шанса ударных действий поразить дополнительного врага',
  'strike_3_3': '+8% к увеличению шанса ударных действий поразить дополнительного врага',
  'strike_3_4': '+3% к увеличению скорости ударных действий',
  'strike_3_5': '+20% к дополнительному шансу ударных действий поразить дополнительного врага · Удары имеют +10% шанс всплеска',

  'life_0_0': '+5% к увеличению максимального здоровья',
  'life_0_1': '+5% физического и гнилостного сопротивления',
  'life_0_2': '+12% к увеличению максимального здоровья',
  'life_0_3': '+5% к увеличению максимального здоровья',
  'life_0_4': '+5% стихийного сопротивления',
  'life_0_5': '+30% к дополнительному максимальному здоровью',
  'life_0_6': '+5% к увеличению максимального здоровья',
  'life_0_7': '+5% физического и гнилостного сопротивления',
  'life_0_8': '+7% физического и гнилостного сопротивления · +7% стихийного сопротивления',
  'life_0_9': '+5% к увеличению максимального здоровья',
  'life_0_10': '+5% стихийного сопротивления',
  'life_0_11': '+30% к дополнительному максимальному здоровью',
  'life_0_12': 'Увеличенная и дополнительная регенерация здоровья также применяется к максимальному здоровью · Вы не можете похищать здоровье',
  'life_0_13': '+20% к дополнительному максимальному здоровью · Урон от действий снижен на 10%',
  'life_0_14': '+1% к увеличению максимального здоровья за каждый уровень здоровья',
  'life_0_15': '+10% к дополнительному максимальному здоровью',

  'life_1_0': '+5% физического и гнилостного сопротивления',
  'life_1_1': '+5% стихийного сопротивления',
  'life_1_2': '+7% физического и гнилостного сопротивления · +7% стихийного сопротивления',
  'life_1_3': '+5% физического и гнилостного сопротивления',
  'life_1_4': '+5% стихийного сопротивления',
  'life_1_5': '5% урона, поглощённого вашими сопротивлениями, восстанавливается как здоровье',
  'life_1_6': '+5% физического и гнилостного сопротивления',
  'life_1_7': '+5% стихийного сопротивления',
  'life_1_8': '+7% физического и гнилостного сопротивления · +7% стихийного сопротивления',
  'life_1_9': '+5% физического и гнилостного сопротивления',
  'life_1_10': '+5% стихийного сопротивления',
  'life_1_11': 'Эффекты снижения сопротивлений, применяемые к вам, теряют 50% эффективности',
  'life_1_12': '+7% физического и гнилостного сопротивления · -7% стихийного сопротивления',
  'life_1_13': '+7% стихийного сопротивления · -7% физического и гнилостного сопротивления',
  'life_1_14': '+7% ко всем сопротивлениям · Максимальное здоровье снижено на 10%',
  'life_1_15': '+15% ко всем сопротивлениям · Вы не можете похищать здоровье',

  'life_2_0': '+5% к увеличению регенерации здоровья',
  'life_2_1': '+5% к увеличению регенерации здоровья',
  'life_2_2': '+12% к увеличению регенерации здоровья',
  'life_2_3': '+5% к увеличению регенерации здоровья',
  'life_2_4': '+5% к увеличению регенерации здоровья',
  'life_2_5': '+0,3% от максимального здоровья восстанавливается в секунду',
  'life_2_12': 'Регенерация здоровья удвоена · Максимальное похищаемое здоровье за удар снижено на 30%',
  'life_2_13': 'Регенерация здоровья удвоена · -5% ко всем сопротивлениям',

  'life_3_0': 'Похищайте +0,5% урона от попаданий действий в виде здоровья',
  'life_3_1': '+5% к увеличению похищаемого здоровья',
  'life_3_2': '+10% к увеличению предела похищения здоровья',
  'life_3_3': 'Похищайте +0,5% урона от попаданий действий в виде здоровья',
  'life_3_4': '+5% к увеличению похищаемого здоровья',
  'life_3_5': 'Похищение здоровья имеет 1% шанс активировать Пиршественный раж',
  'life_3_12': '+30% к дополнительному максимальному похищению здоровья за удар · Вы не можете регенерировать здоровье',
  'life_3_13': 'Вы можете похищать здоровье от урона недугов',

  'mana_0_0': '+5% к увеличению максимальной маны',
  'mana_0_1': '+2% к увеличению максимальной маны · +2% к увеличению регенерации маны',
  'mana_0_2': '+12% к увеличению максимальной маны',
  'mana_0_3': '+5% к увеличению максимальной маны',
  'mana_0_4': '+2% к увеличению максимальной маны · +2% к увеличению регенерации маны',
  'mana_0_5': '+20% к дополнительной максимальной мане',
  'mana_0_6': '+5% к увеличению максимальной маны',
  'mana_0_7': '+2% к увеличению максимальной маны · +2% к увеличению регенерации маны',
  'mana_0_8': '+15% к увеличению максимальной маны · +5% к увеличению регенерации маны · +5% к увеличению скорости действий',
  'mana_0_9': '+5% к увеличению максимальной маны',
  'mana_0_10': '+2% к увеличению максимальной маны · +2% к увеличению регенерации маны',
  'mana_0_11': '+20% к дополнительной максимальной мане · +3% к дополнительному максимальному здоровью',

  'mana_1_0': 'Щит маны поглощает +5% входящего урона от попаданий',
  'mana_1_1': 'Стоимость конвертации щита маны снижена на 5%',
  'mana_1_2': 'Щит маны поглощает +10% входящего урона от попаданий',
  'mana_1_3': 'Щит маны поглощает +5% входящего урона от попаданий',
  'mana_1_4': 'Стоимость конвертации щита маны снижена на 5%',
  'mana_1_5': 'Щит маны теперь перехватывает все источники урона',
  'mana_1_6': 'Щит маны поглощает +5% входящего урона от попаданий',
  'mana_1_7': 'Стоимость конвертации щита маны снижена на 5%',
  'mana_1_8': 'Щит маны поглощает +10% входящего урона от попаданий',
  'mana_1_9': 'Щит маны поглощает +5% входящего урона от попаданий',
  'mana_1_10': 'Стоимость конвертации щита маны снижена на 5%',
  'mana_1_11': 'Ваши сопротивления снижают стоимость конвертации щита маны',

  'mana_2_0': '+5% к увеличению регенерации маны',
  'mana_2_1': '+5% к увеличению регенерации маны',
  'mana_2_2': '+12% к увеличению регенерации маны',
  'mana_2_3': '+5% к увеличению регенерации маны',
  'mana_2_4': '+5% к увеличению регенерации маны',
  'mana_2_5': '+10% шанс, что действие восполнит ману вместо того, чтобы тратить её',

  'mana_3_0': 'Похищайте +0,5% урона от попаданий действий в виде маны',
  'mana_3_1': '+5% к увеличению похищаемой маны',
  'mana_3_2': '+10% к увеличению предела похищения маны',
  'mana_3_3': 'Похищайте +0,5% урона от попаданий действий в виде маны',
  'mana_3_4': '+5% к увеличению похищаемой маны',
  'mana_3_5': 'Похищение маны имеет 1% шанс активировать Пиршественный раж',

  'enemy_0_0': '+50% к увеличению шанса появления дополнительного врага',
  'enemy_0_1': '+25% к увеличению шанса появления 2 дополнительных врагов',
  'enemy_0_2': '+1 гарантированное появление врага',
  'enemy_0_3': '+50% к увеличению шанса появления дополнительного врага',
  'enemy_0_4': '+25% к увеличению шанса появления 2 дополнительных врагов',
  'enemy_0_5': '+2 гарантированных появления врагов · Как минимум одно появление врага — сильный тип',
  'enemy_0_6': '+50% к увеличению шанса появления дополнительного врага',
  'enemy_0_7': '+25% к увеличению шанса появления 2 дополнительных врагов',
  'enemy_0_8': '+1 гарантированное появление врага',
  'enemy_0_9': '+50% к увеличению шанса появления дополнительного врага',
  'enemy_0_10': '+25% к увеличению шанса появления 2 дополнительных врагов',
  'enemy_0_11': '+2 гарантированных появления врагов · Как минимум одно появление врага — элитный тип',

  'enemy_1_0': '+5% к увеличению шанса, что враг будет сильным',
  'enemy_1_1': '+10% к увеличению шанса, что сильный враг будет элитным',
  'enemy_1_2': '+12% к увеличению шанса, что враг будет сильным',
  'enemy_1_3': '+5% к увеличению шанса, что враг будет сильным',
  'enemy_1_4': '+10% к увеличению шанса, что сильный враг будет элитным',
  'enemy_1_5': 'Как минимум одно появление врага — сильный тип · Как минимум одно появление врага — элитный тип',
  'enemy_1_6': '+5% к увеличению шанса, что враг будет сильным',
  'enemy_1_7': '+10% к увеличению шанса, что сильный враг будет элитным',
  'enemy_1_8': '+12% к увеличению шанса, что враг будет сильным',
  'enemy_1_9': '+5% к увеличению шанса, что враг будет сильным',
  'enemy_1_10': '+10% к увеличению шанса, что сильный враг будет элитным',
  'enemy_1_11': '+20% к увеличению шанса, что враг будет сильным · +20% к увеличению шанса, что сильный враг будет элитным · +1 гарантированное появление врага',

  'enemy_2_0': '+5% шанс, что элитный враг станет чемпионом',
  'enemy_2_1': '+5% к увеличению шанса, что враг будет сильным · +5% к увеличению шанса, что сильный враг будет элитным',
  'enemy_2_2': '+5% шанс, что враг будет сильным · +5% шанс, что сильный враг будет элитным · +5% шанс, что элитный враг станет чемпионом',
  'enemy_2_3': '+5% шанс, что элитный враг станет чемпионом',
  'enemy_2_4': '+5% к увеличению шанса, что враг будет сильным · +5% к увеличению шанса, что сильный враг будет элитным',
  'enemy_2_5': '+1% шанс, что враг-чемпион станет боссом',

  'enemy_3_0': '+10% шанс при убийстве породить дополнительного врага в следующей волне',
  'enemy_3_1': '+10% шанс при убийстве породить дополнительного врага в следующей волне',
  'enemy_3_2': 'На 15% больше врагов порождается',
  'enemy_3_3': '+10% шанс при убийстве породить дополнительного врага в следующей волне',
  'enemy_3_4': '+10% шанс при убийстве породить дополнительного врага в следующей волне',
  'enemy_3_5': 'На 20% больше врагов порождается',

  'movement_0_0': '+5% к увеличению скорости передвижения',
  'movement_0_1': '+5% к увеличению скорости передвижения',
  'movement_0_2': '+12% к увеличению скорости передвижения',
  'movement_0_3': '+5% к увеличению скорости передвижения',
  'movement_0_4': '+5% к увеличению скорости передвижения',
  'movement_0_5': '+15% к дополнительной скорости передвижения',
  'movement_0_6': '+5% к увеличению скорости передвижения',
  'movement_0_7': '+5% к увеличению скорости передвижения',
  'movement_0_8': '+12% к увеличению скорости передвижения',
  'movement_0_9': '+5% к увеличению скорости передвижения',
  'movement_0_10': '+5% к увеличению скорости передвижения',
  'movement_0_11': 'Дебаффы замедления передвижения, применяемые к вам, имеют на 50% меньшую эффективность',
  'movement_0_12': 'Первое действие после передвижения наносит на 10% больше урона',
  'movement_0_13': '+1% к урону от действий за каждое последовательное действие без передвижения, до 10%',
  'movement_0_14': 'Вы невосприимчивы к эффектам замедления передвижения',
  'movement_0_15': '+15% к дополнительной скорости передвижения',

  'movement_1_0': '+20% к увеличению шанса получить заряд Рывка каждую секунду',
  'movement_1_1': '+10% к увеличению дистанции Рывка',
  'movement_1_2': '+30% к увеличению шанса получить заряд Рывка каждую секунду · +10% к увеличению дистанции Рывка',
  'movement_1_3': '+20% к увеличению шанса получить заряд Рывка каждую секунду',
  'movement_1_4': '+10% к увеличению дистанции Рывка',
  'movement_1_5': '+50% к увеличению шанса получить заряд Рывка каждую секунду',
  'movement_1_12': 'Рывок может иметь на один дополнительный заряд · Дистанция Рывка снижена на 20%',
  'movement_1_13': 'Рывок всегда пытается сократить расстояние до ближайшего врага, независимо от дальности действий',

  'movement_2_0': '+25% вашей скорости передвижения используется для Уклонения, когда враги находятся в пределах половины вашей дальности действий',
  'movement_2_1': '+25% вашей скорости передвижения используется для Уклонения, когда враги находятся в пределах половины вашей дальности действий',
  'movement_2_2': '+5 ко всем сопротивлениям во время Уклонения',
  'movement_2_3': '+25% вашей скорости передвижения используется для Уклонения, когда враги находятся в пределах половины вашей дальности действий',
  'movement_2_4': '+25% вашей скорости передвижения используется для Уклонения, когда враги находятся в пределах половины вашей дальности действий',
  'movement_2_5': 'Рывок можно использовать для Уклонения от врагов',
  'movement_2_12': 'Постоянно уклоняйтесь, пока цель в радиусе действия, отступая до 90% дальности действия',
  'movement_2_13': '+5% к увеличению скорости действий во время Уклонения',

  'cold_0_0':  '+5% к увеличению урона холодом',
  'cold_0_1':  '+3% к увеличению скорости действий холодом',
  'cold_0_2':  '+5% к увеличению урона холодом · +5% к увеличению шанса заморозки',
  'cold_0_3':  '+5% к увеличению урона холодом',
  'cold_0_4':  '+3% к увеличению скорости действий холодом',
  'cold_0_5':  '10% больше урона холодом',
  'cold_0_6':  '+5% к увеличению урона холодом',
  'cold_0_7':  '+3% к увеличению скорости действий холодом',
  'cold_0_8':  '+12% к увеличению урона холодом',
  'cold_0_9':  '+5% к увеличению урона холодом',
  'cold_0_10': '+3% к увеличению скорости действий холодом',
  'cold_0_11': 'Замороженные враги получают на 20% больше урона от не-холодных источников',

  'cold_1_0':  '+5% к увеличению шанса заморозки',
  'cold_1_1':  '+3% к увеличению замедления от мороза',
  'cold_1_2':  '+5% к увеличению замедления · +10% к увеличению длительности мороза',
  'cold_1_3':  '+5% к увеличению шанса заморозки',
  'cold_1_4':  '+3% к увеличению замедления от мороза',
  'cold_1_5':  '+8% к увеличению замедления · +20% к увеличению длительности мороза',
  'cold_1_6':  '+5% к увеличению шанса заморозки',
  'cold_1_7':  '+3% к увеличению замедления от мороза',
  'cold_1_8':  '+15% к увеличению шанса заморозки',
  'cold_1_9':  '+5% к увеличению шанса заморозки',
  'cold_1_10': '+3% к увеличению замедления от мороза',
  'cold_1_11': 'На 15% больше эффект замедления от мороза',
  'cold_1_12': '+5% к увеличению замедления от мороза · на 10% меньше длительность мороза',
  'cold_1_13': 'На 20% больше длительность мороза',
  'cold_1_14': 'Замороженные враги наносят на 10% меньше урона',
  'cold_1_15': '+5% к увеличению замедления от мороза',

  'cold_2_0':  'Враги, убитые в заморозке, имеют +5% шанс расколоться',
  'cold_2_1':  'Урон от Разрушения увеличен на 2% от максимального здоровья расколотого врага',
  'cold_2_2':  'Враги, убитые в заморозке, имеют +8% шанс расколоться · +20% к увеличению области действия Разрушения',
  'cold_2_3':  'Враги, убитые в заморозке, имеют +5% шанс расколоться',
  'cold_2_4':  'Урон от Разрушения увеличен на 2% от максимального здоровья расколотого врага',
  'cold_2_5':  'Враги, убитые в заморозке, имеют +10% шанс расколоться · урон от Разрушения увеличен на 3% от максимального здоровья расколотого врага',

  'cold_3_0':  'Ледяному доспеху требуется на 20 заморозок меньше для получения заряда',
  'cold_3_1':  '1% снижения урона от ударов за каждый заряд Ледяного доспеха',
  'cold_3_2':  '30% шанс получить 2 заряда Ледяного доспеха вместо 1 · на 20% медленнее расход зарядов',
  'cold_3_3':  'Ледяному доспеху требуется на 20 заморозок меньше для получения заряда',
  'cold_3_4':  '1% снижения урона от ударов за каждый заряд Ледяного доспеха',
  'cold_3_5':  'Ледяной доспех может иметь на 5 максимальных зарядов больше',
}
